// JobbArea — the candidate "Jobb" area: job-search only (Lediga tjänster · Mina
// ansökningar). Invitations are NOT here — an invite isn't always about
// job-seeking (an employer can invite existing staff just for onboarding), so it
// lives on Home (the persistent "Du har en inbjudan" card) + the bell, which
// deep-link to the standalone /dashboard/my-invitations page.
import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Briefcase, FileText, Bell, Lightbulb } from 'lucide-react';
import { PillTabs } from '@/components/custom-ui/PillTabs';
import { ExplainerCard } from '@/components/custom-ui/ExplainerCard';
import { NEXILINK_SPACING } from '@/lib/nexilink-card-styles';
import JobBoardPage from './JobBoardPage';
import MyApplicationsPage from './MyApplicationsPage';
import BevakningarPage from './BevakningarPage';

const JobbArea: React.FC = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const active = location.pathname.includes('/my-applications')
        ? 'applications'
        : location.pathname.includes('/bevakningar')
            ? 'bevakningar'
            : 'jobs';
    const go = (k: string) =>
        navigate(
            k === 'applications'
                ? '/dashboard/my-applications'
                : k === 'bevakningar'
                    ? '/dashboard/bevakningar'
                    : '/dashboard/jobs',
        );

    return (
        <div className={NEXILINK_SPACING}>
            <ExplainerCard id="candidate-jobb" icon={Lightbulb} tone="amber" title="Så funkar Jobb">
                <p className="text-sm text-gray-600 mt-0.5">
                    Sök och filtrera <strong>lediga tjänster</strong>, spara en sökning som <strong>bevakning</strong> för notis vid nya träffar, och följ dina inskickade <strong>ansökningar</strong> — allt här.
                </p>
            </ExplainerCard>
            <PillTabs
                tabs={[
                    { key: 'jobs', label: 'Lediga tjänster', icon: Briefcase },
                    { key: 'bevakningar', label: 'Bevakningar', icon: Bell },
                    { key: 'applications', label: 'Mina ansökningar', icon: FileText },
                ]}
                active={active}
                onChange={go}
            />
            {active === 'jobs' ? (
                <JobBoardPage />
            ) : active === 'bevakningar' ? (
                <BevakningarPage />
            ) : (
                <MyApplicationsPage />
            )}
        </div>
    );
};

export default JobbArea;
